var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenseNonideal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_radial_13933_33208)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13933_33208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5583 14H23.4539C21.0014 14 19 16.0014 19 18.4539V47.4681C19 49.9207 21.0014 51.922 23.4539 51.922H29.2961C30.129 57.3593 34.8375 61.5472 40.5061 61.5472C42.1952 61.5472 43.8032 61.177 45.2493 60.506L50.4899 65.7466C51.2534 66.5101 52.2599 66.9035 53.2779 66.9035C54.296 66.9035 55.2909 66.5217 56.066 65.7466C56.575 65.2376 56.575 65.2376 56.066 65.7466C57.6046 64.208 57.6046 61.7091 56.066 60.1821L50.8138 54.9415C51.2534 53.9928 51.5658 52.9864 51.7277 51.922H57.5699C60.0224 51.922 62.0238 49.9207 62.0238 47.4681V18.4539C62.0123 16.0014 60.0109 14 57.5583 14ZM54.0067 63.6989C54.0067 63.6989 52.9424 64.1038 52.526 63.6989L50.1544 61.3274L47.7828 58.9558L49.2636 57.475L54.0067 62.2181C54.4117 62.6346 54.0067 63.6989 54.0067 63.6989Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1205 47.4683C59.1205 48.3359 58.4148 49.0301 57.5587 49.0301H51.786C51.196 43.3267 46.3603 38.8612 40.5065 38.8612C34.6528 38.8612 29.8055 43.3267 29.2271 49.0301H23.4543C22.5983 49.0301 21.8926 48.3244 21.8926 47.4683V18.4541C21.8926 17.598 22.5983 16.8923 23.4543 16.8923H57.5587C58.4264 16.8923 59.1205 17.598 59.1205 18.4541V47.4683Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2972 20.3859H26.7176C25.9193 20.3859 25.2715 21.0337 25.2715 21.8319C25.2715 22.6302 25.9193 23.278 26.7176 23.278H54.2972C55.0955 23.278 55.7433 22.6302 55.7433 21.8319C55.7433 21.0337 55.0955 20.3859 54.2972 20.3859Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2972 26.2051H26.7176C25.9193 26.2051 25.2715 26.8529 25.2715 27.6512C25.2715 28.4494 25.9193 29.0972 26.7176 29.0972H54.2972C55.0955 29.0972 55.7433 28.4494 55.7433 27.6512C55.7433 26.8529 55.0955 26.2051 54.2972 26.2051Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5118 32.0239H32.5008C31.7025 32.0239 31.0547 32.6718 31.0547 33.47C31.0547 34.2682 31.7025 34.9161 32.5008 34.9161H48.5118C49.31 34.9161 49.9579 34.2682 49.9579 33.47C49.9579 32.6718 49.31 32.0239 48.5118 32.0239Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5036 58.6549C45.1741 58.6549 48.9602 54.8688 48.9602 50.1983C48.9602 45.5278 45.1741 41.7416 40.5036 41.7416C35.8331 41.7416 32.0469 45.5278 32.0469 50.1983C32.0469 54.8688 35.8331 58.6549 40.5036 58.6549Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1036 50.1637C38.2707 49.3539 37.4493 48.5556 36.6511 47.7458C36.4891 47.5839 36.3503 47.3641 36.2809 47.1443C36.1652 46.7162 36.385 46.2882 36.7668 46.0684C37.1485 45.8601 37.5997 45.8948 37.9352 46.2303C38.6062 46.8782 39.2656 47.5376 39.9134 48.197C40.087 48.3705 40.2605 48.5672 40.5381 48.868C40.7117 48.6366 40.8389 48.4284 41.0125 48.2548C41.6603 47.5954 42.3197 46.936 42.9907 46.2766C43.4534 45.8254 44.0434 45.8139 44.4599 46.2303C44.8648 46.6468 44.8417 47.2368 44.3905 47.6995C43.6848 48.4168 42.9791 49.1225 42.2734 49.8282C42.1693 49.9323 42.0652 50.048 41.9032 50.2215C42.6205 50.9272 43.3262 51.6098 44.0319 52.3039C44.136 52.408 44.2285 52.5005 44.3327 52.6047C44.8417 53.1137 44.888 53.7037 44.4599 54.1317C44.0319 54.5598 43.4303 54.5251 42.9328 54.0276C42.2966 53.4029 41.6719 52.7782 41.0472 52.1419C40.8852 51.9684 40.7348 51.7833 40.515 51.5172C40.2721 51.7948 40.0985 52.0031 39.9019 52.1998C39.3119 52.7898 38.7219 53.3798 38.1319 53.9582C37.5766 54.5135 36.9981 54.5713 36.547 54.1201C36.1073 53.6805 36.1768 53.1021 36.7436 52.5352C37.4146 51.8643 38.0856 51.1933 38.745 50.5339C38.8491 50.4413 38.9532 50.3372 39.1036 50.1637Z",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13933_33208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5 7) rotate(66.1979) scale(79.7862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13933_33208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.0123,
    height: 52.9035,
    fill: "white",
    transform: "translate(19 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseNonideal);
export default __webpack_public_path__ + "static/media/expenseNonideal.a52136eb536928eff416a1832b2ca042.svg";
export { ForwardRef as ReactComponent };